import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { FetchEditHistory } from "../../../Slices/Thunk/employeeThunk";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
const EditHistory = () => {
  const dispatch = useDispatch();
  const { Empid } = useParams();
  const [pagination, setPagination] = useState({
  current: 1,
  pageSize: 10,
});


  const workHistory = useSelector((state) => state.employee.editHistory) || [];
  const workHistoryData = workHistory?.history?.map((item) => ({
    key: item.id,
    userName: item.userName,
    action: item.action,
    EditStatus: item.EditStatus,
    empid: item.empid,
    changeTime: item.changeTime,
  }));



const handlePageChange = (page, pageSize) => {
  setPagination({
    current: page,
    pageSize: pageSize,
  });
};

  useEffect(() => {
  if (Empid) {
    dispatch(
      FetchEditHistory({
        id: Empid,
        page: pagination, // contains current + pageSize
      })
    );
  }
}, [Empid, pagination, dispatch]);


  const workHistoryColumns = [
    {
      title: "Updated By",
      dataIndex: "userName",
      key: "userName",
      align: "center",
      width: 180,

      render: (text) => (text ? <span title={text}>{text}</span> : "N/A"),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      width: 150,

      render: (text) => (text ? <span title={text}>{text}</span> : "N/A"),
    },
    {
      title: "Status",
      dataIndex: "EditStatus",
      key: "EditStatus",
      align: "center",
      width: 120,
      render: (text) => (text ? <span title={text}>{text}</span> : "N/A"),
    },
    {
      title: "Updated At",
      dataIndex: "changeTime",
      key: "changeTime",
      align: "center",
      width: 200,
      render: (text) => <span title={text}>{dayjs(text).format('DD/MM/YYYY hh:mm:s')}</span>,
    },
  ];

  return (
    <CustomGridTable
      columns={workHistoryColumns}
      dataSource={workHistoryData}
      rowKey="key"
      Id="edit-history-table"
     pagination={{
  current: pagination.current,
  pageSize: pagination.pageSize,
  total: workHistory?.totalCount || 0,
  showSizeChanger: true,  
  pageSizeOptions: ["10", "50", "100", "200"], 
   showTotal: (total, range) =>
    `${range[0]}-${range[1]} of ${total} items`, 
  onChange: handlePageChange,
}}

      scroll={{ x: false }}
      size="small"
    />

  );
};

export default EditHistory;
